module.exports = __webpack_public_path__ + "static/media/classroom.a389fc83.svg";